module.exports = __webpack_public_path__ + "static/media/desc-title@2x.49c4fa02.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/desc-title@2x.png
// module id = 1123
// module chunks = 0